var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-tag"},[_vm._v(" "+_vm._s(_vm.option.title)+" "),_c('div',{staticClass:"multi-tag-close",on:{"click":function($event){return _vm.$emit('delete')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }